import { HTTP } from './helpers/http.js'

export default {
  getImpactMetrics(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/impact-metrics`
    return HTTP.get(url)
  },

  getRules(organizationId) {
    const url = `/api/v1/organizations/${organizationId}/settings/impact-metrics/rules`
    return HTTP.get(url)
  },

  updateRule(organizationId, { ruleId, isEnabled }) {
    const url = `/api/v1/organizations/${organizationId}/settings/impact-metrics/rules/${ruleId}`

    return HTTP.patch(url, { isEnabled })
  },

  createRule(organizationId, { metricId, isEnabled }) {
    const url = `/api/v1/organizations/${organizationId}/settings/impact-metrics/rules`
    return HTTP.post(url, { isEnabled, metricId })
  },
}
